// Shared inbox unread-badge state.
//
// Owned here (not inside Sidebar) so both the desktop Sidebar and the mobile
// bottom-nav read the exact same signal and stay in sync. The Sidebar drives
// the fetch/refresh (gated on auth + wired to the SSE `juuplan:inbox-refresh`
// event); this module just holds the value and the refresh helper.
import { signal } from "@preact/signals";
import { inboxCount } from "./api";

export const inboxUnreadSig = signal<number>(0);

export function refreshInboxCount(): void {
  void inboxCount()
    .then((res) => {
      inboxUnreadSig.value = res.unread;
    })
    .catch(() => {
      /* silent — badge simply stays at its last value */
    });
}
